import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { AuthProvider } from '../../providers/auth/auth';
import { DeviceType } from '../../models/models';
import { DeviceProvider } from '../../providers/device/device';

@IonicPage()
@Component({
	selector: 'page-message-show',
	templateUrl: 'message-show.html',
})
export class MessageShowPage {
	public message: any;

	/**
	Se non impostato o null usa le logiche di auth, altrimenti forza il risultato del controllo di visualizzabilità
	*/
	_isShowable: boolean = null;
	get isShowable(): boolean {
		if (this._isShowable === null) {
			return this.auth.canMessageShow(this.message);
		}
		return this._isShowable;
	}
	set isShowable(value: boolean) {
		this._isShowable = value;
	}

	constructor(
		private auth: AuthProvider,
		private devices: DeviceProvider,
		private navCtrl: NavController,
		private navParams: NavParams
	) {
		this.message = navParams.get("message");
		this.isShowable = navParams.get('isShowable');//valore o null
	}
	ionViewWillUnload() {
		//se il contesto lo richiede esegue il logout in uscita
		switch (this.devices.actualType) {
			case DeviceType.DASHBOARD:
			case DeviceType.INTERCOM:
				if (this.auth.user) {
					this.auth.logout();
				}
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/message-show/message-show.ts